module.exports = __webpack_public_path__ + "img/IMG_2254_L_Wood_MockedUp.d5de4592.jpg";